// src/App.js
import React, { useState, useEffect } from 'react';
import Game from './components/Game';
import Herbarium from './components/Herbarium';
import FlowerCard from './components/FlowerCard';
import { floresDB } from './data/floresDB';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('menu'); // 'menu', 'game', 'flowerCard', 'herbarium'
  const [selectedFlower, setSelectedFlower] = useState(null);
  const [discoveredFlowers, setDiscoveredFlowers] = useState(() => {
    const saved = localStorage.getItem('discoveredFlowers');
    return saved ? JSON.parse(saved) : [];
  });
  const [score, setScore] = useState(0);

  useEffect(() => {
    localStorage.setItem('discoveredFlowers', JSON.stringify(discoveredFlowers));
  }, [discoveredFlowers]);

  const handleFlowerDiscovered = (flower) => {
    if (!discoveredFlowers.find(df => df.id === flower.id)) {
      setDiscoveredFlowers(prev => [...prev, flower]);
    }
    setSelectedFlower(flower);
    setCurrentView('flowerCard');
  };

  const handleCorrectAnswer = (points) => {
    setScore(prev => prev + points);
  };

  const renderView = () => {
    switch (currentView) {
      case 'game':
        return (
          <Game
            flowers={floresDB}
            onFlowerDiscovered={handleFlowerDiscovered}
            onCorrectAnswer={handleCorrectAnswer}
            discoveredFlowers={discoveredFlowers}
            setCurrentView={setCurrentView}
          />
        );
      case 'flowerCard':
        return (
          <FlowerCard
            flower={selectedFlower}
            onClose={() => setCurrentView('game')} // O al menú/herbario
          />
        );
      case 'herbarium':
        return (
          <Herbarium
            discoveredFlowers={discoveredFlowers}
            onSelectFlower={(flower) => {
              setSelectedFlower(flower);
              setCurrentView('flowerCard');
            }}
            onClose={() => setCurrentView('menu')}
          />
        );
      case 'menu':
      default:
        return (
          <div className="menu">
            <h1>Florapedia Explorer</h1>
            <p>Puntuación: {score}</p>
            <button onClick={() => setCurrentView('game')}>Iniciar Juego</button>
            <button
              onClick={() => setCurrentView('herbarium')}
              disabled={discoveredFlowers.length === 0}
            >
              Mi Herbario ({discoveredFlowers.length})
            </button>
            <p className="credits">
              Un minijuego de C.T. para aprender sobre flores.
                			  ¡Diviértete!
            </p>
          </div>
        );
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        {currentView !== 'menu' && (
          <button className="menu-button" onClick={() => setCurrentView('menu')}>
            Menú Principal
          </button>
        )}
      </header>
      <main>
        {renderView()}
      </main>
    </div>
  );
}

export default App;